import { ClientState, defaultClientState, clientForm } from "./state";
import { Action } from "redux";
import { changeStatusCreateClientModalAction, changeClientSavingFlag } from "./actions";
import { getCountryListRequest } from "@common";

export function clientReducer(state: ClientState = defaultClientState, action: Action): ClientState {
    if (clientForm.actions.isMyAction(action)) {
        return {
            ...state,
            clientForm: clientForm.reducer(state.clientForm, action)
        };
    }

    if (changeStatusCreateClientModalAction.is(action)) {
        return {
            ...state,
            isOpenCreateClient: action.isOpen,
            clientForm: clientForm.state.empty()
        };
    }

    if (getCountryListRequest.actions.isMy(action)) {
        return {
            ...state,
            countryList: getCountryListRequest.reducer(state.countryList, action)
        };
    }

    if (changeClientSavingFlag.is(action)) {
        return {
            ...state,
            clientSavingFlag: action.status
        };
    }

    return state;
}
